import { TabList } from '@mui/lab';
import { styled, Tab } from '@mui/material';

export const GeneralTabsContainer = styled(TabList)(({ theme }) => ({
  minHeight: '32px',
  maxHeight: '32px',
  border: `1px solid ${theme.palette.case.neutral.n200}`,
  borderRadius: '8px',
  backgroundColor: 'transparent',
  padding: '3px',

  '& .MuiTabs-flexContainer': {
    gap: '4px',
    height: '100%',
  },

  '& .MuiTabs-indicator': {
    display: 'none',
  },

  [theme.breakpoints.down('sm')]: {
    '& .MuiTabs-flexContainer': {
      padding: '0',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
}));

export const GeneralTabsItem = styled(Tab)(({ theme }) => ({
  textTransform: 'capitalize',
  fontSize: '16px',
  padding: '6px 10px',
  height: '100%',
  minHeight: 'initial',
  minWidth: 'initial',
  color: theme.palette.case.neutral.n600,

  '&.Mui-selected': {
    backgroundColor: theme.palette.case.neutral.n800,
    borderRadius: '5px',

    '&.MuiTab-textColorPrimary': {
      color: theme.palette.case.contrast.white,
    },
  },

  [theme.breakpoints.down('sm')]: {
    minWidth: '40px',
  },
}));
